import { authenticatedAxios, axiosInstance } from '../../utils/axios'
import CONSTANTS from '../../utils/constants'
import ENDPOINTS from '../constant'

export const isMcnActive = async () => {
  let responseData = { active: false, error: null }
  try {
    const res = await authenticatedAxios.get(
      `${ENDPOINTS.mcn.root}${ENDPOINTS.mcn.isServiceActive}`
    )
    if (res.data.responseCode === CONSTANTS.SUCCESS) {
      responseData.active = true
    } else if (res.data.responseCode === CONSTANTS.EMPTY_STATE) {
      responseData.active = false
    } else {
      responseData.error = res.data.responseMessage
    }
  } catch {
    responseData.error = 'General Error while getting is MCN active'
  }
  return responseData
}

export const getMcnTermsAndConditions = async () => {
  let responseData = { data: '', error: null }
  try {
    const res = await authenticatedAxios.get(
      `${ENDPOINTS.mcn.root}${ENDPOINTS.mcn.termsAndConditions}`
    )
    if (res.data.responseCode === CONSTANTS.SUCCESS) {
      responseData.data = res.data.responseMessage
    } else {
      responseData.error = res.data.responseMessage
    }
  } catch {
    responseData.error = 'General Error while getting MCN terms'
  }
  return responseData
}
export const subscribeMcn = async () => {
  let responseData = { success: false, error: null }
  try {
    const res = await authenticatedAxios.put(
      `${ENDPOINTS.mcn.root}${ENDPOINTS.mcn.addMcn}`
    )
    if (res.data.responseCode === CONSTANTS.SUCCESS) {
      responseData.success = true
    } else {
      responseData.error = res.data.responseMessage
    }
  } catch {
    responseData.error = 'General Error while adding MCN service'
  }
  return responseData
}
export const unsubscribeMcn = async () => {
  let responseData = { success: false, error: null }
  try {
    const res = await authenticatedAxios.delete(
      `${ENDPOINTS.mcn.root}${ENDPOINTS.mcn.removeMcn}`
    )
    if (res.data.responseCode === CONSTANTS.SUCCESS) {
      responseData.success = true
    } else {
      responseData.error = res.data.responseMessage
    }
  } catch {
    responseData.error = 'General Error while deleting MCN service'
  }
  return responseData
}

export const microLoansEligibility = async () => {
  let responseData = { eligible: false, error: null }
  try {
    const res = await authenticatedAxios.get(
      `${ENDPOINTS.microLoans.root}${ENDPOINTS.microLoans.checkEligibility}`
    )
    if (res.data.responseCode === CONSTANTS.SUCCESS) {
      responseData.eligible = true
    } else {
      responseData.error = res.data.responseMessage
    }
  } catch {
    responseData.error = 'General Error while getting micro loans eligibility'
  }
  return responseData
}

export const checkMaddedhaEligibility = async () => {
  let responseData = { eligible: false, error: null }
  try {
    const res = await authenticatedAxios.get(
      `${ENDPOINTS.extraServices.root}${ENDPOINTS.extraServices.checkMaddedhaEligibility}`
    )
    if (res.data.responseCode === CONSTANTS.SUCCESS) {
      responseData.active = true
    } else if (res.data.responseCode === CONSTANTS.EMPTY_STATE) {
      responseData.active = false
    } else {
      responseData.error = res.data.responseMessage
    }
  } catch {
    responseData.error = 'General Error while getting is Maddedha active'
  }
  return responseData
}

export const checkSafeInternetEligibility = async () => {
  let responseData = { eligible: false, error: null }
  try {
    const res = await authenticatedAxios.get(
      `${ENDPOINTS.extraServices.root}${ENDPOINTS.extraServices.checkSafeInternetEligibility}`
    )
    if (res.data.responseCode === CONSTANTS.SUCCESS) {
      responseData.eligible = true
    } else {
      responseData.error = res.data.responseMessage
    }
  } catch {
    responseData.error = 'General Error while getting safe internet status'
  }
  return responseData
}

export const subscribeSafeInternet = async () => {
  let responseData = { success: false, error: null }
  try {
    const res = await authenticatedAxios.get(
      `${ENDPOINTS.extraServices.root}${ENDPOINTS.extraServices.subscribeSafeInternet}`
    )
    if (res.data.responseCode === CONSTANTS.SUCCESS) {
      responseData.success = true
    } else {
      responseData.error = res.data.responseMessage
    }
  } catch {
    responseData.error = 'General Error while subscribing to is safe internet'
  }
  return responseData
}

export const extraServiceDetails = async (option, number) => {
  let responseData = { data: [], error: null }
  try {
    const res = await authenticatedAxios.get(
      `${ENDPOINTS.extraServices.root}${ENDPOINTS.extraServices.getExtraBundleDetails}`,
      {
        params: { option: option, destMsisdn: number ? number : null },
      }
    )
    if (res.data.responseCode === CONSTANTS.SUCCESS) {
      responseData.data = res.data.result
    } else {
      responseData.data = res.data.result
      responseData.error = res.data.responseMessage
    }
  } catch {
    responseData.error = `General Error while getting ${
      option === 1 ? 'maddedha' : 'safe internet'
    } details`
  }
  return responseData
}

export const disconnectReasons = async () => {
  let responseData = { data: [], error: null }
  try {
    const res = await authenticatedAxios.get(
      `${ENDPOINTS.disconnect.root}${ENDPOINTS.disconnect.disconnectReasons}`
    )
    if (res.data.responseCode === CONSTANTS.SUCCESS) {
      responseData.data = res.data.result
    } else {
      responseData.error = res.data.responseMessage
    }
  } catch {
    responseData.error = 'General Error while getting disconnect reasons'
  }
  return responseData
}

export const checkConnectYourLineEligibility = async () => {
  let responseData = { eligible: false, error: null }
  try {
    const res = await authenticatedAxios.get(
      `${ENDPOINTS.reconnect.root}${ENDPOINTS.reconnect.isCustomerAllowedToReconnectAfterBO}`
    )
    if (res.data.responseCode === CONSTANTS.SUCCESS) {
      responseData.eligible = true
    } else {
      responseData.error = res.data.responseMessage
    }
  } catch {
    responseData.error =
      'General Error while getting is check your line eligibility'
  }
  return responseData
}

export const isAllowedToDisConnect = async () => {
  let responseData = { allowed: false, error: null }
  try {
    const res = await authenticatedAxios.get(
      `${ENDPOINTS.disconnect.root}${ENDPOINTS.disconnect.isCustomerAllowedToDisconnect}`
    )
    if (res.data.responseCode === CONSTANTS.SUCCESS) {
      responseData.allowed = true
    } else {
      responseData.error = res.data.responseMessage
    }
  } catch {
    responseData.error = 'General Error while getting disconnect reasons'
  }
  return responseData
}

export const getConnectYourLineTerms = async () => {
  let responseData = { data: [], error: null }
  try {
    const res = await authenticatedAxios.get(
      `${ENDPOINTS.reconnect.root}${ENDPOINTS.reconnect.reconnectAfterBOTermsAndConditions}`
    )
    if (res.data.responseCode === CONSTANTS.SUCCESS) {
      responseData.data = res.data.responseMessage
    } else {
      responseData.error = res.data.responseMessage
    }
  } catch {
    responseData.error =
      'General Error while getting is connect your line terms'
  }
  return responseData
}

export const isAllowedToReConnect = async () => {
  let responseData = { allowed: false, error: null }
  try {
    const res = await authenticatedAxios.get(
      `${ENDPOINTS.reconnect.root}${ENDPOINTS.reconnect.isCustomerAllowedToReconnect}`
    )
    if (res.data.responseCode === CONSTANTS.SUCCESS) {
      responseData.allowed = true
    } else {
      responseData.error = res.data.responseMessage
    }
  } catch {
    responseData.error = 'General Error while trying to reconnect'
  }
  return responseData
}

export const getMicroLoansTermsAndConditions = async () => {
  let responseData = { data: '', error: null }
  try {
    const res = await authenticatedAxios.get(
      `${ENDPOINTS.microLoans.root}${ENDPOINTS.microLoans.termsAndConditions}`
    )
    if (res.data.responseCode === CONSTANTS.SUCCESS) {
      responseData.data = res.data.responseMessage
    } else {
      responseData.error = res.data.responseMessage
    }
  } catch {
    responseData.error = 'General Error while getting micro loans terms'
  }
  return responseData
}
export const connectYourLineReconnect = async () => {
  let responseData = { success: false, message: '', error: null }
  try {
    const res = await authenticatedAxios.get(
      `${ENDPOINTS.reconnect.root}${ENDPOINTS.reconnect.reconnectAfterBO}`
    )
    if (res.data.responseCode === CONSTANTS.SUCCESS) {
      responseData.success = true
      responseData.message = res.data.responseMessage
    } else {
      responseData.error = res.data.responseMessage
    }
  } catch {
    responseData.error = 'General Error while reconnecting connect your line'
  }
  return responseData
}

export const disconnectTermsAndConditions = async () => {
  let responseData = { data: '', error: null }
  try {
    const res = await authenticatedAxios.get(
      `${ENDPOINTS.disconnect.root}${ENDPOINTS.disconnect.disconnectTermsAndConditions}`
    )
    if (res.data.responseCode === CONSTANTS.SUCCESS) {
      responseData.data = res.data.responseMessage
    } else {
      responseData.error = res.data.responseMessage
    }
  } catch {
    responseData.error = 'General Error while getting disconnect terms'
  }
  return responseData
}
export const getMicroLoans = async () => {
  let responseData = { data: '', error: null }
  try {
    const res = await authenticatedAxios.get(
      `${ENDPOINTS.microLoans.root}${ENDPOINTS.microLoans.getMicroLoans}`
    )
    if (res.data.responseCode === CONSTANTS.SUCCESS) {
      responseData.data = res.data.result
    } else {
      responseData.error = res.data.responseMessage
    }
  } catch {
    responseData.error = 'General Error while getting micro loans values'
  }
  return responseData
}

export const subscribeMaddedha = async () => {
  let responseData = { success: false, error: null }
  try {
    const res = await authenticatedAxios.get(
      `${ENDPOINTS.extraServices.root}${ENDPOINTS.extraServices.subscribeMaddedha}`
    )
    if (res.data.responseCode === CONSTANTS.SUCCESS) {
      responseData.success = true
    } else {
      responseData.error = res.data.responseMessage
    }
  } catch {
    responseData.error = 'General Error while subscribing to maddedha'
  }
  return responseData
}

export const getTopServiceInVASSection = async () => {
  let responseData = { topService: [], error: null }
  try {
    const res = await authenticatedAxios.get(
      `${ENDPOINTS.bundleCat.root}${ENDPOINTS.bundleCat.getTopServices}`
    )
    if (res.data.responseCode === CONSTANTS.SUCCESS) {
      responseData.topService = res.data.result
    } else {
      responseData.error = res.data.responseMessage
    }
  } catch (e) {
    responseData.error = 'Error while getting top service Information In VAS'
  }
  return responseData
}
export const getBundlesByCategory = async (type) => {
  let responseData = { data: [], error: null }
  try {
    const res = await authenticatedAxios.get(
      `${ENDPOINTS.bundleCat.root}${ENDPOINTS.bundleCat.getBundlesByCat}?BundleCategory=${type}`
    )
    if (res.data.responseCode === CONSTANTS.SUCCESS) {
      res.data.result.forEach(function (serviceInfo) {
        responseData.data.push({
          id: serviceInfo.catId,
          name: serviceInfo.catName,
          catDescription: serviceInfo.catDescription,
          catType: serviceInfo.catType,
          myAccountServices: serviceInfo.myAccountServices,
          isRenewable: serviceInfo.isRenewable,
        })
      })
    } else {
      responseData.error = res.data.responseMessage
    }
  } catch (e) {
    responseData.error = `Error while getting ${type} bundles data`
  }
  return responseData
}
export const getBundlesByCatId = async (id) => {
  let responseData = { bundlesData: [], error: null }
  try {
    const res = await authenticatedAxios.get(
      `${ENDPOINTS.bundleCat.root}${ENDPOINTS.bundleCat.getBundleByCatId}?CategoryId=${id}`
    )
    if (res.data.responseCode === CONSTANTS.SUCCESS) {
      res.data.result.forEach(function (bundleInfo) {
        responseData.bundlesData.push({
          id: bundleInfo.serviceId,
          name: bundleInfo.serviceName,
          description: bundleInfo.description,
          serviceType: bundleInfo.serviceType,
          showInActiveServices: bundleInfo.showInActiveServices,
          catId: bundleInfo.catId,
          isActiveService: bundleInfo.isActiveService,
          isSubscribed: bundleInfo.isSubscribed,
          bundlePrice: bundleInfo.bundlePrice,
          renew: bundleInfo.renew,
          subscribe: bundleInfo.subscribe,
          unSubscribe: bundleInfo.unSubscribe,
        })
      })
    } else {
      responseData.error = res.data.responseMessage
    }
  } catch (e) {
    responseData.error = `Error while getting bundles data`
  }
  return responseData
}
export const getBalanceTransferTermsAndCondition = async () => {
  let responseData = { data: [], error: null }
  try {
    const res = await authenticatedAxios.get(
      `${ENDPOINTS.toPupTransfer.root}${ENDPOINTS.toPupTransfer.getTransferBalanceTerms}`
    )
    if (res.data.responseCode === CONSTANTS.SUCCESS) {
      responseData.data = res.data.responseMessage
    } else {
      responseData.error = res.data.responseMessage
    }
  } catch (e) {
    responseData.error =
      'Error while getting terms and condition for Balance Transfer service'
  }
  return responseData
}
export const reconnectTermsAndConditions = async () => {
  let responseData = { data: '', error: null }
  try {
    const res = await authenticatedAxios.get(
      `${ENDPOINTS.reconnect.root}${ENDPOINTS.reconnect.reconnectTermsAndConditions}`
    )
    if (res.data.responseCode === CONSTANTS.SUCCESS) {
      responseData.data = res.data.responseMessage
    } else {
      responseData.error = res.data.responseMessage
    }
  } catch {
    responseData.error =
      'General Error while getting terms and conditions for reconnect'
  }
  return responseData
}
export const getMicroLoansAmounts = async () => {
  let responseData = { data: '', error: null }
  try {
    const res = await authenticatedAxios.get(
      `${ENDPOINTS.microLoans.root}${ENDPOINTS.microLoans.microLoansAmount}`
    )
    if (res.data.responseCode === CONSTANTS.SUCCESS) {
      responseData.data = res.data.result
    } else {
      responseData.error = res.data.responseMessage
    }
  } catch {
    responseData.error = 'General Error while getting micro loans amounts'
  }
  return responseData
}
export const getDisconnect = async (reason ,alternativeNumber) => {
  let responseData = { data: {}, success: false, error: null }
  try {
    const res = await authenticatedAxios.post(
      `${ENDPOINTS.disconnect.root}${ENDPOINTS.disconnect.root}`,
      {
        reasonCode: reason,
        alternativeNumber: alternativeNumber
      }
    )
    if (res.data.responseCode === CONSTANTS.SUCCESS) {
      responseData.data = res.data
      responseData.success = true
    } else {
      responseData.error = res.data
    }
  } catch {
    responseData.error = 'General error while disconnecting number'
  }
  return responseData
}
export const getReconnect = async () => {
  let responseData = { data: {}, success: false, error: null }
  try {
    const res = await authenticatedAxios.get(
      `${ENDPOINTS.reconnect.root}${ENDPOINTS.reconnect.root}`
    )
    if (res.data.responseCode === CONSTANTS.SUCCESS) {
      responseData.data = res.data
      responseData.success = true
    } else {
      responseData.error = res.data
    }
  } catch {
    responseData.error = 'General error while reconnecting number'
  }
  return responseData
}
export const getTransferBalanceOptionsFromAPI = async () => {
  let responseData = { data: [], error: null }
  try {
    const res = await authenticatedAxios.get(
      `${ENDPOINTS.toPupTransfer.root}${ENDPOINTS.toPupTransfer.getTransferBalanceOptions}`
    )
    if (res.data.responseCode === CONSTANTS.SUCCESS) {
      responseData.data = res.data.result
    } else {
      responseData.error = res.data.responseMessage
    }
  } catch (e) {
    responseData.error =
      'Error while getting options for Balance Transfer service'
  }
  return responseData
}
export const purchaseMicroLoans = async (id, price) => {
  let responseData = { data: '', success: false, error: null }
  try {
    const res = await authenticatedAxios.get(
      `${ENDPOINTS.microLoans.root}${ENDPOINTS.microLoans.purchaseMicroLoan}`,
      {
        params: { LoanId: id, Price: price },
      }
    )
    if (res.data.responseCode === CONSTANTS.SUCCESS) {
      responseData.data = res.data.responseMessage
      responseData.success = true
    } else {
      responseData.error = res.data.responseMessage
    }
  } catch {
    responseData.error = 'General Error while getting micro loans amounts'
  }
  return responseData
}
export const sendCodeForBalanceTransfer = async () => {
  let responseData = { isSend: false, error: null }
  try {
    const res = await authenticatedAxios.post(
      `${ENDPOINTS.toPupTransfer.root}${ENDPOINTS.toPupTransfer.sendTransferBalanceCode}`,
      {
        osType: CONSTANTS.OS_TYPE,
      }
    )
    if (res.data.responseCode === CONSTANTS.SUCCESS) {
      responseData.isSend = true
    } else {
      responseData.error = res.data.responseMessage
    }
  } catch (e) {
    responseData.error = 'Error while sending code for Balance Transfer service'
  }
  return responseData
}
export const executeTransferBalance = async (data) => {
  let responseData = {
    isExecuteSuccessfully: false,
    successfulMsg: '',
    error: null,
  }
  try {
    const res = await authenticatedAxios.post(
      `${ENDPOINTS.toPupTransfer.root}${ENDPOINTS.toPupTransfer.executeTransferBalance}`,
      data
    )
    if (res.data.responseCode === CONSTANTS.SUCCESS) {
      responseData.isExecuteSuccessfully = true
      responseData.successfulMsg = res.data.responseMessage
    } else {
      responseData.error = res.data.responseMessage
    }
  } catch (e) {
    responseData.error = 'Error while execute Balance Transfer service'
  }
  return responseData
}
export const addNumberToSelectedNumberService = async (data) => {
  let responseData = {
    isAddedSuccessfully: false,
    successfulMsg: '',
    error: null,
  }
  try {
    const res = await authenticatedAxios.post(
      `${ENDPOINTS.selectedNumber.root}${ENDPOINTS.selectedNumber.addNumber}`,
      data
    )
    if (res.data.responseCode === CONSTANTS.SUCCESS) {
      responseData.isAddedSuccessfully = true
      responseData.successfulMsg = res.data.responseMessage
    }
    responseData.error = res.data.responseMessage
  } catch (e) {
    responseData.error =
      'Error while adding new number in selected number service'
  }
  return responseData
}
export const replaceNumberToSelectedNumberService = async (data) => {
  let responseData = {
    isReplaceSuccessfully: false,
    successfulMsg: '',
    error: null,
  }
  try {
    const res = await authenticatedAxios.post(
      `${ENDPOINTS.selectedNumber.root}${ENDPOINTS.selectedNumber.replaceNumber}`,
      data
    )
    if (res.data.responseCode === CONSTANTS.SUCCESS) {
      responseData.isReplaceSuccessfully = true
      responseData.successfulMsg = res.data.responseMessage
    }
    responseData.error = res.data.responseMessage
  } catch (e) {
    responseData.error =
      'Error while replacing new number in selected number service'
  }
  return responseData
}
export const showListOfSelectedNumber = async (faFId) => {
  let responseData = {
    hasSelectedNumber: false,
    selectedNumberValues: [],
    error: null,
  }
  try {
    const res = await authenticatedAxios.post(
      `${ENDPOINTS.selectedNumber.root}${ENDPOINTS.selectedNumber.showNumbersList}`,
      { FafID: faFId }
    )
    if (res.data.responseCode === CONSTANTS.SUCCESS && res.data.result.length) {
      responseData.hasSelectedNumber = true
      responseData.selectedNumberValues = res.data.result
    } else {
      responseData.error = res.data.responseMessage
    }
  } catch (e) {
    responseData.error = 'Error while getting list of selected numbers'
  }
  return responseData
}
export const getListOfAllowedFafsInSelectedNumberService = async () => {
  let responseData = { listOfAllowedFafs: [], error: null }
  try {
    const res = await authenticatedAxios.post(
      `${ENDPOINTS.selectedNumber.root}${ENDPOINTS.selectedNumber.getListOfAllowedFafs}`
    )
    if (res.data.responseCode === CONSTANTS.SUCCESS) {
      responseData.listOfAllowedFafs = res.data.result
    } else {
      responseData.error = res.data.responseMessage
    }
  } catch (e) {
    responseData.error =
      'Error while getting list of allowed Fafs in selected Number Service '
  }
  return responseData
}
export const getMixRefillOptions = async () => {
  let responseData = { listOfRefillOptions: [], error: null }
  try {
    const res = await authenticatedAxios.get(
      `${ENDPOINTS.mixRefill.root}${ENDPOINTS.mixRefill.getMixRefillOptions}`
    )
    if (res.data.responseCode === CONSTANTS.SUCCESS) {
      responseData.listOfRefillOptions = res.data.result
    } else {
      responseData.error = res.data.responseMessage
    }
  } catch (e) {
    responseData.error = 'Error while getting list of mix refill Options '
  }
  return responseData
}
export const executeMixRefill = async (amount) => {
  let responseData = { isSuccess: false, msgSuccess: '', error: null }
  try {
    const res = await authenticatedAxios.post(
      `${ENDPOINTS.mixRefill.root}${ENDPOINTS.mixRefill.executeMixRefill}`,
      {
        Amount: amount,
      }
    )
    if (res.data.responseCode === CONSTANTS.SUCCESS) {
      responseData.isSuccess = true
      responseData.msgSuccess = res.data.responseMessage
    } else {
      responseData.error = res.data.responseMessage
    }
  } catch (e) {
    responseData.error = 'Error while executing Mix refill service '
  }
  return responseData
}

export const getStopInternetEligibility = async () => {
  let responseData = {
    isEligible: true,
    error: null,
  }
  try {
    const res = await authenticatedAxios.get(
      `${ENDPOINTS.stopInternet.root}${ENDPOINTS.stopInternet.isEligible}`
    )
    if (res.data.responseCode === CONSTANTS.SUCCESS) {
      responseData.isEligible = res.data.result
    } else if (res.data.responseCode === -3) {
      responseData.isEligible = false
    } else {
      responseData.error = res.data.responseMessage
    }
  } catch (e) {
    responseData.error = 'Error while checking Stop Internet eligibility'
  }
  return responseData
}

export const checkIsStopNetActive = async () => {
  let responseData = {
    isActive: false,
    productId: '',
    error: null,
  }
  try {
    const res = await authenticatedAxios.get(
      `${ENDPOINTS.stopInternet.root}${ENDPOINTS.stopInternet.isActive}`
    )
    if (res.data.responseCode === CONSTANTS.SUCCESS) {
      responseData.isActive = true
    }
    responseData.productId = res.data.result
  } catch (e) {
    responseData.error = 'Error while checking Stop Active Net Service '
  }
  return responseData
}
export const activateStopInternetService = async (productId) => {
  let responseData = {
    isSuccess: false,
    successfulMsg: '',
    error: null,
  }
  try {
    const res = await authenticatedAxios.post(
      `${ENDPOINTS.stopInternet.root}${ENDPOINTS.stopInternet.activateStopInternet}`,
      {
        productId: productId,
      }
    )
    if (res.data.responseCode === CONSTANTS.SUCCESS) {
      responseData.isSuccess = true
      responseData.successfulMsg = res.data.responseMessage
    } else {
      responseData.error = res.data.responseMessage
    }
  } catch (e) {
    responseData.error = 'Error while activate Stop  Net Service '
  }
  return responseData
}
export const deactivateStopInternetService = async (productId) => {
  let responseData = {
    isSuccess: false,
    successfulMsg: '',
    error: null,
  }
  try {
    const res = await authenticatedAxios.post(
      `${ENDPOINTS.stopInternet.root}${ENDPOINTS.stopInternet.deactivateStopInternet}`,
      {
        productId: productId,
      }
    )
    if (res.data.responseCode === CONSTANTS.SUCCESS) {
      responseData.isSuccess = true
      responseData.successfulMsg = res.data.responseMessage
    } else {
      responseData.error = res.data.responseMessage
    }
  } catch (e) {
    responseData.error = 'Error while deactivate Stop  Net Service '
  }
  return responseData
}
export const getContentData = async (key, jsonMap = false) => {
  let responseData = {
    key: '',
    contentData: [],
    error: null,
  }
  try {
    const res = await authenticatedAxios.get(
      `${ENDPOINTS.staticContent.root}${ENDPOINTS.staticContent.getContent}?key=${key}&jsonMap=${jsonMap}`
    )
    if (res.data.responseCode === CONSTANTS.SUCCESS) {
      if (jsonMap) {
        responseData.contentData = res.data.result
      } else {
        responseData.key = res.data.result.key
        responseData.contentData = res.data.result.value
      }
    } else {
      responseData.error = res.data.responseMessage
    }
  } catch (e) {
    responseData.error = 'Error while getting content data'
  }
  return responseData
}

export const getPublicContentData = async (key, jsonMap = false) => {
  let responseData = {
    key: '',
    contentData: [],
    error: null,
  }
  try {
    const res = await axiosInstance.get(
      `${ENDPOINTS.staticContent.root}${ENDPOINTS.staticContent.getContent}?key=${key}&jsonMap=${jsonMap}`
    )
    if (res.data.responseCode === CONSTANTS.SUCCESS) {
      if (jsonMap) {
        responseData.contentData = res.data.result
      } else {
        responseData.key = res.data.result.key
        responseData.contentData = res.data.result.value
      }
    } else {
      responseData.error = res.data.responseMessage
    }
  } catch (e) {
    responseData.error = 'Error while getting content data'
  }
  return responseData
}
export const refillVoucherService = async (bodyData) => {
  let responseData = {
    isSuccess: false,
    successfulMsg: '',
    error: null,
  }
  try {
    const res = await authenticatedAxios.post(
      `${ENDPOINTS.RefillVoucher.root}${ENDPOINTS.RefillVoucher.refillVoucher}`,
      bodyData
    )
    if (res.data.responseCode === CONSTANTS.SUCCESS) {
      responseData.isSuccess = true
      responseData.successfulMsg = res.data.responseMessage
    } else {
      responseData.error = res.data.responseMessage
    }
  } catch (e) {
    responseData.error = 'Error while recharge using Voucher '
  }
  return responseData
}
export const getServiceDetails = async (queryParam) => {
  let responseData = { serviceDetails: [], error: null }
  try {
    const res = await authenticatedAxios.get(
      `${ENDPOINTS.bundleCat.root}${ENDPOINTS.bundleCat.getServiceDetails}?${queryParam}`
    )
    if (res.data.responseCode === CONSTANTS.SUCCESS) {
      responseData.serviceDetails = res.data
    } else {
      responseData.error = res.data.responseMessage
    }
  } catch (e) {
    responseData.error = 'Error while getting service details'
  }
  return responseData
}

export const callMeBack = async (data) => {
  let responseData = { data: {}, responseMessage: '', error: null }
  try {
    const res = await authenticatedAxios.post(
      `${ENDPOINTS.extraServices.root}${ENDPOINTS.extraServices.cmbsms}`,
      data
    )
    if (res.data.responseCode === CONSTANTS.SUCCESS) {
      responseData.responseMessage = res.data.responseMessage
    } else {
      responseData.error = res.data.responseMessage
    }
  } catch (e) {
    responseData.error = 'Error '
  }
  return responseData
}
export const getLatestTransactions = async () => {
  let responseData = { latestTransactions: [], error: null }
  try {
    const res = await authenticatedAxios.get(
      `${ENDPOINTS.extraServices.root}${ENDPOINTS.extraServices.latestTransactions}`
    )
    if (res.data.responseCode === CONSTANTS.SUCCESS) {
      responseData.latestTransactions = res.data
    } else {
      responseData.error = res.data.responseMessage
    }
  } catch (e) {
    responseData.error = 'Error while getting latest transactions'
  }
  return responseData
}
export const getCMBTermsAndConditions = async () => {
  let responseData = { CMBTermsAndConditions: [], error: null }
  try {
    const res = await authenticatedAxios.get(
      `${ENDPOINTS.extraServices.root}${ENDPOINTS.extraServices.cbmTermsAndConditions}`
    )
    if (res.data.responseCode === CONSTANTS.SUCCESS) {
      responseData.CMBTermsAndConditions = res.data
    } else {
      responseData.error = res.data.responseMessage
    }
  } catch (e) {
    responseData.error = 'Error while getting CMB Terms And Conditionss'
  }
  return responseData
}
export const GetBalanceDeductionHistory = async (fromDate, toDate, youth) => {
  let responseData = { data: [], noData: false, error: null }
  try {
    const res = await authenticatedAxios.get(
      `${ENDPOINTS.usage.root}${ENDPOINTS.usage.getBalanceDeductionHistory}`,
      {
        params: { startDate: fromDate, endDate: toDate, youth: youth },
      }
    )
    if (res.data.responseCode === CONSTANTS.SUCCESS) {
      responseData.data = res.data.result
    }
    if (res.data.responseCode > 0) {
      responseData.noData = true
      responseData.error = res.data.responseMessage
    } else {
      responseData.error = res.data.responseMessage
    }
  } catch (e) {
    responseData.error = 'Error while getting Balance Deduction History'
  }
  return responseData
}
export const checkEligibility = async (destMsisdn) => {
  let responseData = {
    responseMessage: '',
    error: null,
  }
  try {
    const res = await authenticatedAxios.get(
      `${ENDPOINTS.gifting.root}${ENDPOINTS.gifting.checkEligibility}?destMsisdn=${destMsisdn}`
    )
    if (res.data.responseCode === CONSTANTS.SUCCESS) {
      responseData.responseMessage = res.data.responseMessage
    } else {
      responseData.error = res.data.responseMessage
    }
  } catch (e) {
    responseData.error = 'Error while checking Eligibility  '
  }
  return responseData
}
export const getRecommendedGifts = async (category, destMsisdn) => {
  let responseData = {
    recommendedGifts: [],
    statusCode: 0,
    msg: '',
    error: null,
  }
  try {
    const res = await authenticatedAxios.get(
      `${ENDPOINTS.gifting.root}${ENDPOINTS.gifting.getRecommendedGifts}?category=${category}&destMsisdn=${destMsisdn}`
    )
    if (res.data.responseCode >= 0 || res.data.responseCode < 0) {
      responseData.statusCode = res.data.responseCode
      responseData.recommendedGifts = res.data.result
      responseData.msg = res.data.responseMessage
    } else {
      responseData.error = res.data.responseMessage
    }
  } catch (e) {
    responseData.error = 'Error while getting Recommended Gifts '
  }
  return responseData
}
export const sendGifts = async (data) => {
  let responseData = {
    responseMessage: '',
    error: null,
  }
  try {
    const res = await authenticatedAxios.post(
      `${ENDPOINTS.gifting.root}${ENDPOINTS.gifting.sendGift}`,
      data
    )
    if (res.data.responseCode === CONSTANTS.SUCCESS) {
      responseData.responseMessage = res.data.responseMessage
    } else {
      responseData.error = res.data.responseMessage
    }
  } catch (e) {
    responseData.error = 'Error while sending Gifts '
  }
  return responseData
}
export const getTermsAndConditions = async () => {
  let responseData = { TermsAndConditions: [], error: null }
  try {
    const res = await authenticatedAxios.get(
      `${ENDPOINTS.gifting.root}${ENDPOINTS.gifting.termsAndConditions}`
    )
    if (res.data.responseCode === CONSTANTS.SUCCESS) {
      responseData.TermsAndConditions = res.data
    } else {
      responseData.error = res.data.responseMessage
    }
  } catch (e) {
    responseData.error = 'Error while getting Terms And Conditionss'
  }
  return responseData
}

export const microLoansIsAllowed = async () => {
  let responseData = { data: '', error: null }
  try {
    const res = await authenticatedAxios.get(
      `${ENDPOINTS.microLoans.root}${ENDPOINTS.microLoans.isAllowed}`
    )
    if (res.data.responseCode === CONSTANTS.SUCCESS) {
      responseData.data = res.data.result
    } else {
      responseData.error = res.data.responseMessage
    }
  } catch {
    responseData.error = 'General Error'
  }
  return responseData
}

export const getEligibleAndCurrentLoansfromAPI = async () => {
  let responseData = { data: '', error: null }
  try {
    const res = await authenticatedAxios.get(
      `${ENDPOINTS.microLoans.root}${ENDPOINTS.microLoans.eligibleAndCurrentLoans}`
    )
    if (res.data.responseCode === CONSTANTS.SUCCESS) {
      responseData.data = res.data.result
    } else {
      responseData.error = res.data.responseMessage
    }
  } catch {
    responseData.error = 'General Error while getting micro loans'
  }
  return responseData
}

export const purchaseLoan = async (data) => {
  let responseData = {
    responseMessage: '',
    error: null,
  }
  try {
    const res = await authenticatedAxios.post(
      `${ENDPOINTS.microLoans.root}${ENDPOINTS.microLoans.purchase}`,
      data
    )
    if (res.data.responseCode === CONSTANTS.SUCCESS) {
      responseData.responseMessage = res.data.responseMessage
    } else {
      responseData.error = res.data.responseMessage
    }
  } catch (e) {
    responseData.error = 'Error while purchase loan '
  }
  return responseData
}

export const microLoansTermsAndCond = async () => {
  let responseData = { data: [], error: null }
  try {
    const res = await authenticatedAxios.get(
      `${ENDPOINTS.microLoans.root}${ENDPOINTS.microLoans.termsAndConditions}`
    )
    if (res.data.responseCode === CONSTANTS.SUCCESS) {
      responseData.data = res.data.result
    } else {
      responseData.error = res.data.responseMessage
    }
  } catch {
    responseData.error = 'General Error while getting micro loans'
  }
  return responseData
}
export const maddedhaGetBundlesfromAPI = async (destMsisdn) => {
  let responseData = {
    data: [],
    responseMessage: '',
    error: null,
  }
  try {
    const res = await authenticatedAxios.get(
      `${ENDPOINTS.extraServices.root}${ENDPOINTS.extraServices.maddedha.root}${ENDPOINTS.extraServices.maddedha.getBundles}?destMsisdn=${destMsisdn}`
    )
    if (res.data.responseCode === CONSTANTS.SUCCESS) {
      responseData.data = res.data.result
    } else {
      responseData.error = res.data.responseMessage
    }
  } catch (e) {
    responseData.error = 'Error while getting maddedha bundles'
  }
  return responseData
}
export const madedhaSubscribe = async (data) => {
  let responseData = {
    responseMessage: '',
    error: null,
  }
  try {
    const res = await authenticatedAxios.post(
      `${ENDPOINTS.extraServices.root}${ENDPOINTS.extraServices.maddedha.root}${ENDPOINTS.extraServices.maddedha.subscribe}`,
      data
    )
    if (res.data.responseCode === CONSTANTS.SUCCESS) {
      responseData.responseMessage = res.data.responseMessage
    } else {
      responseData.error = res.data.responseMessage
    }
  } catch (e) {
    responseData.error = 'Error while subscribe maddedha service'
  }
  return responseData
}
export const maddedhaGetTermsAndConditions = async () => {
  let responseData = {
    data: [],
    responseMessage: '',
    error: null,
  }
  try {
    const res = await authenticatedAxios.get(
      `${ENDPOINTS.extraServices.root}${ENDPOINTS.extraServices.maddedha.root}${ENDPOINTS.extraServices.maddedha.termsAndConditions}`
    )
    if (res.data.responseCode === CONSTANTS.SUCCESS) {
      responseData.data = res.data.result
    } else {
      responseData.error = res.data.responseMessage
    }
  } catch (e) {
    responseData.error = 'Error while getting maddedha terms and conditions'
  }
  return responseData
}
export const getPaltelBookDistricts = async () => {
  let responseData = {
    price: '',
    districts: [],
    error: '',
  }
  try {
    const res = await authenticatedAxios.get(
      `${ENDPOINTS.extraServices.root}${ENDPOINTS.extraServices.paltelBook.root}${ENDPOINTS.extraServices.paltelBook.getDistricts}`
    )
    if (res.data.responseCode === CONSTANTS.SUCCESS) {
      responseData.districts = res.data.result
    } else {
      responseData.error = res.data.responseMessage
    }
  } catch (error) {
    responseData.error = 'Error accrued while getting districts'
  }
  return responseData
}
export const getPaltelBookFromApi = async (data) => {
  let responseData = { successfulMsg: '', data: [], error: null }
  try {
    const res = await authenticatedAxios.post(
      `${ENDPOINTS.extraServices.root}${ENDPOINTS.extraServices.paltelBook.root}${ENDPOINTS.extraServices.paltelBook.enquiry}`,
      data
    )
    if (res.data.responseCode === CONSTANTS.SUCCESS) {
      responseData.successfulMsg = res.data.responseMessage
      responseData.data = res.data.result
    } else {
      responseData.error = res.data.responseMessage
    }
  } catch {
    responseData.errorMsg = 'Error while getting paltel book'
  }
  return responseData
}

export const getLatestPaymentForOthers = async () => {
  let responseData = {
    price: '',
    latestPayments: [],
    error: '',
  }
  try {
    const res = await authenticatedAxios.get(
      `${ENDPOINTS.invoice.root}${ENDPOINTS.invoice.latestPaymentsForOthers}`,

    )
    if (res.data.responseCode === CONSTANTS.SUCCESS) {
      responseData.latestPayments = res.data.result
      // responseData.latestPayments = []
    } else {
      responseData.error = res.data.responseMessage
    }
  } catch (error) {
    responseData.error = 'Error accrued while getting latest payments for others'
  }
  return responseData
}


export const getOthersBills = async (msisdn) => {
  let responseData = {
    othersBills: [],
    error: null,
    msg:null
  }
  try {
    const res = await authenticatedAxios.get(
      `${ENDPOINTS.invoice.root}${ENDPOINTS.guest.invoices.invoicesEnquiry}?msisdn=${msisdn}`,

    )
    if (res.data.responseCode === CONSTANTS.SUCCESS) {
      responseData.othersBills = res.data.result
    } else {
      responseData.error = res.data.responseMessage
    }
  } catch (error) {
    responseData.error = 'Error accrued while getting others bills'
  }
  return responseData
}

/**
 * PUK inquiry — align URL segment and GET body property names with backend contract.
 * Expected success: result holds PUK (string or { puk | PUK }).
 */
export const inquirePukCode = async ({ idNumber: id, msisdn }) => {
  let responseData = { puk: null, error: null, errorTitle: null }
  try {
    const res = await authenticatedAxios.get(
      `${ENDPOINTS.extraServices.root}${ENDPOINTS.extraServices.pukInquiry.root}${ENDPOINTS.extraServices.pukInquiry.inquire}`,
      {
        params: {
          Id: String(id).trim(),
          Msisdn: String(msisdn).replace(/^0/, '').replace(/\D/g, '').slice(-9), // filtering number to 9 digits
        },
      }
    )


    if (res.data.responseCode === CONSTANTS.SUCCESS) {
      const result = res.data.result
      if (typeof result === 'string') {
        responseData.puk = result
      } else if (result?.puk != null) {
        responseData.puk = String(result.puk)
      } else if (result?.PUK != null) {
        responseData.puk = String(result.PUK)
      } else if (res.data.responseMessage && !/error/i.test(res.data.responseMessage)) {
        responseData.puk = res.data.responseMessage
      }
      responseData.errorTitle = res.data.responseTitle
    } else {
      responseData.error = res.data.responseMessage
      responseData.errorTitle = res.data.responseTitle
    }
  } catch {
    responseData.error = 'General Error while retrieving PUK'
  }
  return responseData
}

